var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timer-wrapper-no"},[_c('div',{staticClass:"timer-wrapper-no__timer-no",on:{"click":_vm.toggleActive}},[_c('ui-countdown-simple',{attrs:{"time":_vm.getTime,"booking":true}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }